import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Slider from "rc-slider";
import ReactPlayer from "react-player";

const Wrap = styled.div`
  position: relative;
  width: 900px;
  height: 145px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50px;
  &.bookmode {
    width: 570px;
    height: 75px;
    background-color: var(--theme-color);
    border-radius: 20px;
    box-sizing: border-box;
    box-shadow: 4px 4px 0px 1px rgba(0, 0, 0, 0.3);
    .close {
      display: block;
      position: absolute;
      top: 22px;
      right: 25px;
    }
    .pay {
      width: 30px;
      height: 30px;
      top: 23px;
      left: 30px;
    }
    .pause {
      width: 30px;
      height: 30px;
      top: 23px;
      left: 30px;
    }
    .stop {
      width: 30px;
      height: 30px;
      top: 23px;
      left: 80px;
    }
    .s-wrap {
      width: 310px;
      position: relative;
      left: 150px;
      top: 28px;
      height: 20px;

      .rc-slider-horizontal {
        height: 20px;
      }
      .rc-slider-handle {
        width: 30px;
        height: 30px;
        margin-top: -6px;
      }
    }
  }
`;

const SliderWrap = styled.div`
  width: 580px;
  position: relative;
  height: 35px;
  left: 260px;
  top: 56px;
`;

const PlayerToggleButton = styled.button`
  display: inline-block;
  width: 55px;
  height: 55px;
  left: 50px;
  top: 45px;
  position: absolute;
  background: url(${require("@assets/img/icon_sound_play.png")}) no-repeat;
  background-size: 100%;
  &.pause {
    background: url(${require("@assets/img/icon_sound_pause.png")}) no-repeat;
    background-size: 100%;
  }
`;

const StopButton = styled.button`
  display: inline-block;
  width: 55px;
  height: 55px;
  left: 136px;
  top: 45px;
  position: absolute;
  background: url(${require("@assets/img/icon_sound_stop.png")});
  background-size: 100%;
`;

const CloseButton = styled.button`
  display: none;
  width: 30px;
  height: 30px;
  background: url(${require("@assets/img/icon_book_sound_close.png")});
`;

const SoundPlayerBar = ({ url, cName, onClose, onEnd }) => {
  const playerRef = useRef();
  const isDraging = useRef(false);
  const [currentSeek, setSeek] = useState(0);
  const [isPlay, setPlay] = useState(false);

  //player callbacks
  const onSoundError = (e) => {
    console.log("onError", e);
  };
  const onSoundEnded = () => {
    onClickStop();
    if (onEnd) onEnd();
  };
  const onSoundProgress = (value) => {
    const { played } = value;
    if (isDraging.current === false) {
      setSeek(played * 100);
    }
  };
  const onSoundDuration = (value) => {};

  // player controls button
  const onClickPlayToggle = () => {
    setPlay(!isPlay);
  };

  const onClickStop = () => {
    setPlay(false);
    setSeek(0);
    playerRef.current.seekTo(0);
  };

  // slider callbacks
  const onBeforeChange = (value) => {
    isDraging.current = true;
  };

  const onChange = (value) => {
    setSeek(value);
  };

  const onAfterChange = (value) => {
    isDraging.current = false;
    playerRef.current.seekTo(value / 100);
    setSeek(value);
  };

  useEffect(() => {
    setSeek(0);
    setTimeout(() => {
      setPlay(true);
    }, 500);
  }, [setPlay, setSeek]);

  useEffect(() => {
    const onVisibilitychange = () => {
      if (document.visibilityState === "visible") {
      } else {
        setPlay(false);
      }
    };
    document.addEventListener("visibilitychange", onVisibilitychange);
    return () => {
      setSeek(0);
      setPlay(false);
      document.removeEventListener("visibilitychange", onVisibilitychange);
    };
  }, []);

  return (
    <Wrap className={cName ? cName : ""}>
      <PlayerToggleButton
        type="button"
        className={isPlay === true ? "play pause" : "pay"}
        onClick={onClickPlayToggle}
      />
      <StopButton type="button" onClick={onClickStop} className="stop" />
      <SliderWrap className="s-wrap">
        <Slider
          onAfterChange={onAfterChange}
          min={0}
          max={100}
          onBeforeChange={onBeforeChange}
          onChange={onChange}
          value={currentSeek}
          step={0}
        />
      </SliderWrap>
      <CloseButton type="button" className="close" onClick={onClose} />
      <ReactPlayer
        progressInterval={100}
        ref={playerRef}
        width="0px"
        height="0px"
        playing={isPlay}
        pip={false}
        volume={1}
        loop={false}
        controls={false}
        onEnded={onSoundEnded}
        onError={onSoundError}
        onProgress={onSoundProgress}
        onDuration={onSoundDuration}
        url={url}
      />
    </Wrap>
  );
};

export default SoundPlayerBar;
